import { ROUTE_DASHBOARD_HOME } from '@/constants/routes';
import useApplicationConfig from '@/hooks/useApplicationConfig';
import { Box, Flex, Heading, IconButton, useMediaQuery } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiMenu } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import NavItem from './components/nav-item.component';
import { PlanUsage } from './components/plan-usage.component';

interface ISidebarProps {
	isOpen: boolean;
	onClose: () => void;
	links: Array<{
		text: string;
		icon: IconType;
		to: string;
	}>;
}

export default function SidebarContent(props: ISidebarProps) {
	const applicationConfig = useApplicationConfig();
	/**
	 * Equivalent to lg on Chakra
	 */
	const [isLg] = useMediaQuery('(min-width: 62em)');

	function handleCloseClick() {
		/**
		 * On mobile we close the menu after clicking a link
		 */
		if (!isLg) {
			props.onClose();
		}
	}

	return (
		<Box
			as="aside"
			bg="white"
			borderRightColor="gray.200"
			borderRightWidth={1}
			data-id="sidebar"
			h="full"
			minW="xs"
			overflow="auto"
			position={{ base: 'fixed', lg: 'static' }}
			transition=".4s ease"
			w="full"
			zIndex={3}
			transform={{
				base: props.isOpen ? 'translateX(0)' : 'translateX(-100%)',
				lg: props.isOpen ? 'translateX(0)' : 'translateX(-100%)',
			}}
			display="flex"
			flexDir="column"
		>
			<Flex h={16} py={3} px={8} alignItems="center" borderBottomWidth={1} borderBottomColor="gray.200" mb={6}>
				<IconButton
					display={{ base: 'flex', lg: 'none' }}
					mr={{ base: 4 }}
					onClick={props.onClose}
					variant="ghost"
					aria-label="toggle menu"
					icon={<FiMenu />}
				/>

				<Heading translate="no" as={Link} to={ROUTE_DASHBOARD_HOME} fontSize="xl" fontWeight={900} color="primary.500">
					{applicationConfig.name}
				</Heading>
			</Flex>

			<Box as="nav">
				{props.links.map((link) => (
					<NavItem onClick={handleCloseClick} key={link.to} icon={link.icon} to={link.to} text={link.text} />
				))}
			</Box>

			<PlanUsage />
		</Box>
	);
}
